<template>
    <z-basePage :title="'操作日志'">
        <div class="search-top">
            <span>来源</span>
            <el-select class="top-choose" v-model="search.type" @change="linkChange">
                <el-option v-for="item in typeArr" :key="item" :value="item" >
                </el-option>
            </el-select>
            <span>栏目类型</span>
            <el-select class="top-choose" v-model="search.column">
                <el-option v-for="item in columnArr" :key="item.val" :value="item.val" :label="item.text">
                </el-option>
            </el-select>
            <span>操作对象</span>
            <el-select class="top-choose" v-model="search.object">
                <el-option v-for="item in typeArr" :key="item" :value="item" >
                </el-option>
            </el-select>
            <span>操作时间</span>
            <el-date-picker class="top-choose" v-model="search.date_start" type="date" placeholder="选择日期" :picker-options="picker_special">
			</el-date-picker>
            <small>~</small>
            <el-date-picker class="top-choose" v-model="search.date_end" type="date" placeholder="选择日期" :picker-options="picker_special">
			</el-date-picker>
            
            <div class="back-btn blue">查询</div>
        </div>
        <div class="back-list">
            <div class="list-head">
                <div>栏目类型</div>
                <div>操作名称</div>
                <div>操作时间</div>
                <div>操作人员</div>
                <div>操作对象</div>
                <div>说明</div>
            </div>
            <z-scrollDiv>
                <div class="list-item"  v-for="item in arr" :key="item">
                    <div>{{ "用户登录" }}</div>
                    <div>{{ "用户登录" }}</div>
                    <div>{{ "2017-09-08 16:12:39" }}</div>
                    <div>{{ "乌拉拉" }}</div>
                    <div>{{ "乌拉拉" }}</div>
                    <div>{{ "登录成功" }}</div>
                </div>
            </z-scrollDiv>
        </div>
    </z-basePage>
</template>

<script>
    import { mapState } from 'vuex'

    export default {

        data(){
            return {
                data:{},
                search:{
                    type:"前台",
                    column:"",
                    object:"",
                    date_start:"",
                    date_end:"",
                },
                typeArr:["前台","后台"],
                columnArr:[],  //栏目

                arr:[0,1],
            }
        },
        computed:{
            ...mapState(["picker_special"]),
            dataList(){
                return this.data.data;
            },
        },
        methods:{
            linkChange(val){   //选项联动
                if(val == "前台"){
                    this.columnArr = [
                        {
                            val:1,
                            text:"奖金分配",
                        },
                        {
                            val:2,
                            text:"职级分配",
                        },
                        {
                            val:3,
                            text:"增岗申请",
                        },
                        {
                            val:4,
                            text:"调岗申请",
                        },
                        {
                            val:5,
                            text:"职员罚单",
                        },
                        {
                            val:6,
                            text:"预算申请",
                        },
                    ]
                }else{  
                     this.columnArr = [
                        {
                            val:1,
                            text:"平台设置",
                        },
                        {
                            val:2,
                            text:"用户管理",
                        },
                        {
                            val:3,
                            text:"个人财务",
                        },
                        {
                            val:4,
                            text:"文档管理",
                        },
                        {
                            val:5,
                            text:"任务管理",
                        },
                    ]   
                }
                this.search.column = "";
            }
        }
    }
</script>

<style lang="less" scoped>
    .back-list{
        margin-top:10px;
    }
    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 15%;
        }
        >div:nth-of-type(2){
            width: 15%;
        }
        >div:nth-of-type(3){
            width: 25%;
        }
        >div:nth-of-type(4){
            width: 15%;
        }
        >div:nth-of-type(5){
            width: 15%;
        }
        >div:last-of-type{
            width: 15%;
            // padding-left: 20%;
        }
    }
</style>


// WEBPACK FOOTER //
// log.vue?7748ec74